import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';

import $ from 'jquery';

@Component({
  selector: 'app-son',
  templateUrl: './son.component.html',
  styleUrls: ['./son.component.scss']
})
export class SonEligibilityComponent implements OnInit {

  deceased = this.appState.get();
  	all_conditions: boolean = false;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	// Form Validation
	formValidate() {

	    // Step#1: Required Inputs and Selects   
	    var inputs = document.querySelectorAll("*[required]");

	    if( inputs.length > 0 ) {
	      for (var i = 0; i < inputs.length; ++i) {
	        var input_elem = <HTMLInputElement>inputs[i];

	        if( input_elem.value == '' ) {
	          inputs[i].parentElement.classList.add("has-error");  
	          input_elem.focus();

	          $('html, body').animate({
	              scrollTop: $( ".has-error" ).offset().top
	          }, 500);

	          return false;
	        
	        } else {
	          inputs[i].parentElement.classList.remove("has-error");  
	        }
	      }
	    }



	    // Step#2: Check Radio Buttons whether they are checked or not
	    var error = false;
	    var radio_buttons_wrap = document.querySelectorAll(".radio-buttons-wrap");

	    for (var i = 0; i < radio_buttons_wrap.length; ++i) {
	      var radio = radio_buttons_wrap[i].querySelectorAll("input[type='radio']");
	      var checked = false;
	      
	      for (var k = 0; k < radio.length; ++k) {
	        var radio_elem = <HTMLInputElement>radio[k];

	        if( radio_elem.checked ) {
	          checked = true;
	          break;
	        }
	      }

	      if( ! checked ) {
	        radio_buttons_wrap[i].parentElement.classList.add("has-error");

	        $('html, body').animate({
	            scrollTop: $( ".has-error" ).offset().top
	        }, 500);

	        return false;

	      } else {
	        radio_buttons_wrap[i].parentElement.classList.remove("has-error");
	      }
	    }


	    return true;
	}

	// Eligibility Check
	eligibilityCheck(deceased: any = false) {
		if( deceased ) {
			this.deceased = deceased;
		}

		// Son Eligibility
	    if( this.deceased.survivors == 'true' && this.deceased['son'].count > 0 ) {

	        for (var k = 0; k < this.deceased['son'].count; ++k) {
	          
	          var this_son = this.deceased['son'].object[k];

	          // If All Fields empty Continue without Checking
	          if( this_son.muslim == "" && this_son.legitimate == "" && this_son.deceased_killer == "" && (this_son.free_person == "true" || this_son.free_person == "") && ((this.deceased.gender == 'Male' && this_son.disowned == "") || this.deceased.gender == 'Female') ) {
	            this.deceased['son'].object[k].eligibility = "";

	            if( deceased ) {
	            	return undefined;
	            }

	            this.deceased['son'].object[k].eligibility = "";
	            continue;
	          
	          } else {

	            // Otherwise Check
	            if( this_son.muslim == "true" && this_son.legitimate == "true" && this_son.deceased_killer == "true" && this_son.free_person == "true" && ((this.deceased.gender == 'Male' && this_son.disowned == "true") || this.deceased.gender == 'Female') ) {
	              
	              this.deceased['son'].object[k].eligibility = "true";
	              this.all_conditions = true;
	            
	            } else {
	              
	              this.deceased['son'].object[k].eligibility = "false";
	              if( this.all_conditions == false )  {
	                this.all_conditions = false;
	              }

	            }
	          }

	        }

	        return this.all_conditions;
	    }
	}


	setValues() {

		if( this.deceased.survivors == 'true' && this.deceased['son'].count > 0 ) {

	        for (var k = 0; k < this.deceased['son'].count; ++k) {
	          
	          var this_son = this.deceased['son'].object[k];

	          // If All Fields empty Continue without Checking
	          if( this_son.muslim == "" ) {
	          	this.deceased['son'].object[k].muslim = "false";
	          }

	          if( this_son.legitimate == "" ) {
	          	this.deceased['son'].object[k].legitimate = "false";
	          }

	          if( this_son.deceased_killer == "" ) {
	          	this.deceased['son'].object[k].deceased_killer = "false";
	          }


	          if( this_son.free_person == "" ) {
	          	this.deceased['son'].object[k].free_person = "false";
	          }

	          if( this.deceased.gender == 'Male' && this_son.disowned == "" ) {
	          	this.deceased['son'].object[k].disowned = "false";
	          } 

	        }
	    }
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {

		// Form Validation
	    if( this.formValidate() == false ) {
	      return;
	    }

		// Eligibility Test
		this.eligibilityCheck();


		// Save
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

  ngOnInit() {
  }

}
